import styled from 'styled-components';

export const Wrapper = styled.div`
	padding: 16px;
	min-width: 400px;

	@media (max-width: 500px) {
		min-width: auto;
	}
`;

export const Content = styled.div`
	margin-bottom: 24px;
`;

export const Description = styled.div`
	color: ${({ theme }) => theme.colors.text.body};
	font-size: 16px;
  font-weight: 400;
	line-height: 1.6;

	p {
		margin: 0 0 12px 0;

		&:last-child {
			margin-bottom: 0;
		}
	}
`;

export const Footer = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 12px;
`;

export const Title = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
  font-size: 24px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.title};

	svg {
		fill: ${({ theme }) => theme.colors.icon.chevron};
	}
`;